export default "__VITE_ASSET__CKP$KzpC__"